import CoursePlanEnquiryEvent from './CoursePlanEnquiryEvent';
export default CoursePlanEnquiryEvent;
